export default __webpack_public_path__ + "media/src/assets/images/file-expand-icon-b186ce297546205fd864bd441ff4ea05.png";